import { type SxProps, type Theme } from "@mui/material";

export const FIELD_MESSAGE_ICON_SIZE = 16;

/**
 * `flexShrink` on the glyph is load-bearing: `FormHelperText` is a block-level `<p>`, so a long
 * message would otherwise squeeze the icon rather than wrap beside it.
 */
export const FIELD_MESSAGE_ROW_SX: SxProps<Theme> = {
  display: "flex",
  alignItems: "center",
  gap: 0.5,
  "& > svg": { flexShrink: 0 },
};

export const FIELD_WARNING_MESSAGE_SX: SxProps<Theme> = (theme) => ({
  color: theme.palette.warning.main,
});
